import Button from "../Button/Button";
import styles from "./Modal.module.css";

export interface ModalProps {
  title: string;
  visible: boolean;
  okText?: string;
  closeText?: string;
  bodyText?: string;
  onConfirm?: () => void;
  onClose: () => void;
  onCancel?: () => void;
  hideCancel?: boolean;
  hideConfirm?: boolean;
}

const Modal = ({
  title,
  visible,
  okText = "OK",
  closeText,
  bodyText,
  onConfirm,
  onClose,
  onCancel,
  hideCancel = false,
  hideConfirm = false,
}: ModalProps) => {
  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  const handleCancel = () => {
    if (onCancel != null) {
      onCancel();
    }
    onClose();
  };

  return visible ? (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.title}>{title}</div>
        {bodyText && (
          <div className={styles.bodyText}>
            {bodyText.split("\n").map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
        )}
        <div className={styles.buttons}>
          {!hideCancel && (
            <Button type="reset" onClick={handleCancel} variant="secondary">
              {closeText || "Cancel"}
            </Button>
          )}
          {!hideConfirm && (
            <Button onClick={handleConfirm}>{okText || "OK"}</Button>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default Modal;
